<template>
	<div class="page-header">
		<t-space :size="8" align="center">
			<t-button size="small" v-if="showBack" theme="default" variant="text" @click="onBack" class="back-btn">
				返回
				<template #suffix>
					<RollbackIcon />
				</template>
			</t-button>
			<h1>
				{{ pageTitle || routeTitle }}
			</h1>
			<t-tag v-if="tagTitle" theme="primary" size="small" variant="light">{{ tagTitle }}</t-tag>
		</t-space>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { RollbackIcon } from 'tdesign-icons-vue-next'
const Router = useRouter()
const props = defineProps({
	title: {
		type: String,
		default: '',
	},
	showBack: {
		type: Boolean,
		default: false,
	},
	tagTitle: {
		type: String,
		default: '',
	},
})

const pageTitle = computed(() => {
	return props.title
})

const Route = useRoute()
const routeTitle = computed(() => {
	return Route.meta.title
})

const onBack = () => {
	Router.back()
}
</script>

<style scoped lang="scss">
.page-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: var(--td-comp-margin-l) 0;
}
</style>
